// extracted by mini-css-extract-plugin
module.exports = {"container":"TariffsTableBlock_container__m_I9P","tableContainer":"TariffsTableBlock_tableContainer__e_zXJ"};